<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">
      <div v-if="apiLoaded || errorText">
        <div v-if="apiLoaded" class="wrap service-czn">

          <div class="service-czn__header">
            <div class="service-czn__filter">
              <h1>Карта сервисов для ЦЗН</h1>
              <div class="two-columns block">
                <div class="left-element">

                  <v-autocomplete
                      dense
                      v-model="categoryFilter"
                      :disabled="$user == null"
                      label="Категория сервиса"
                      :items="categories"
                  ></v-autocomplete>

                  <div>
                    <div class="control">
                      <input type="text" placeholder=" " v-model="searchFilter">
                      <label>Поиск</label>
                    </div>
                  </div>

                  <!--                                    <v-autocomplete-->
                  <!--                                            dense-->
                  <!--                                            label="Фильтры"-->
                  <!--                                            :items="filterList"-->
                  <!--                                            item-text="name"-->
                  <!--                                            return-object-->
                  <!--                                    ></v-autocomplete>-->

                  <v-card-actions>
                    <v-btn
                        class="btn btn-primary"
                        @click="applyFilters()"
                    >
                      Применить
                    </v-btn>
                    <v-btn
                        class="btn btn-outline"
                        text
                        @click="clearFilters()"
                    >
                      Очистить
                    </v-btn>
                  </v-card-actions>
                </div>
                <div class="right-element">
                  <div class="title">Наиболее популярные теги:</div>
                  <ul class="tag-list">
                    <li v-for="tag in topPopularTags()" :key="'tag'+tag"><a href="#"
                                                                            @click.prevent="search(tag)">{{ tag }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="service-czn__buttons">
              <v-btn
                  v-if="$user?.role == 'ROLE_ADMIN'"
                  class="btn btn-primary"
                  @click="$router.push('/config')"
              >
                Настроить состав<br>полей
              </v-btn>

              <v-dialog
                  v-model="dialogNew"
                  max-width="800px"
                  persistent>
                <template v-slot:activator="{ on }">
                  <v-btn
                      v-on="on"
                      class="btn btn-primary"
                      v-if="['ROLE_ADMIN', 'ROLE_VNII'].includes($user.role)"
                  >
                    Создать карточку сервиса
                  </v-btn>
                </template>
                <NewDialog :services="services" @close="onNewDialogClosed()"
                           :key="dialogKey"/>
              </v-dialog>

              <v-btn
                  class="btn btn-outline"
                  text
                  @click="exportStats()"
                  v-if="$user != null && ['ROLE_ADMIN', 'ROLE_VNII'].includes($user.role)"
              >
                Экспорт статистики
              </v-btn>

            </div>
          </div>
          <div class="service-czn__list">
            <template v-for="(service, serviceIndex) in filteredServices">
            <div class="service-czn__item"
                 v-if="checkFilter(service)"
                 :key="'service_' + service.id"
            >

              <div class="service_czn__title">{{ service['short_name'] }}</div>
              <div class="service-czn__body">
                <div class="service-czn__comment"
                     v-for="field in getVisibleFields(service.category)"
                     :key="'field_'+field.id"
                >
                  <p style="color:grey; font-weight: 600;">{{ field.name }}:</p>
                  <template v-if="field.type==='LINK'">
                    <a :href="service[field.id]" target="_blank">{{ service[field.id] }}</a>
                  </template>
                  <template v-else-if="field.type==='FILES'">
                    <p v-for="file in service[field.id]" :key="file.id">
                      <a :href="'/uuidfs/' + file.id" @click.prevent="downloadFile(file.id, file.name)">
                        {{ truncateStr(file.name, 30) }}
                      </a>
                    </p>
                  </template>
                  <template v-else-if="field.type?.startsWith('dict_') && field.multiple">
                    <p v-for="(v, vi) in service[field.id]" :key="'opt'+'_'+field.id+'_'+vi">{{truncateStr(v, 50)}}</p>
                  </template>
                  <template v-else>
                    {{ truncateStr(service[field.id], 250) }}
                  </template>
                </div>

                <div class="service-czn__tag service-czn__comment" v-if="service?.tag"><a href="/">{{ service.tag }}</a></div>

                <div class="service-stat service-czn__comment" v-if="service?.viewsCount || service?.downloadsCount">
                  <div v-if="service?.viewsCount" class="servise-stat__views">Открытий: {{service.viewsCount}}</div>
                  <div v-if="service?.downloadsCount" class="servise-stat__downloads">Скачиваний: {{service.downloadsCount}}</div>
                </div>
                
              </div>
              <div class="service-czn__detail">
                <a @click="serviceDialog(service, serviceIndex)">Подробнее</a>
                <div class="service-czn__buttons">
                  <div class="service-czn__comment document-block" v-if="hasDocuments(service)">
                    <div class="service-download">
                    <div class="service-tooltip">приложен файл</div>
                  </div>
                </div>
                  <div class="service-czn__del" style="" @click="deleteService(service.id)" v-if="$user?.role == 'ROLE_ADMIN'"></div>
                </div>
              </div>
            </div>
            </template>
            <template v-if="filteredServices.length === 0">Нет сервисов, удовлетворяющих критериям фильтрации</template>
          </div>

          <v-dialog
              v-model="dialogEdit"
              max-width="1000px"
              persistent>
            <template v-slot:activator="{ on }">
              <div v-on="on">
              </div>
            </template>
            <EditDialog
                @close="dialogEdit=false; dialogKey++"
                :key="dialogKey"
                :config="config"
                :services="services"
                :serviceId="filteredServices[serviceIndex]?.id"
            />
          </v-dialog>
        </div>
        <div v-if="errorText!=null" class="error" style="position: fixed;bottom: 0">
          Ошибка: {{ errorText }}
        </div>
      </div>
      <div v-else style="height:1000px"></div>
    </transition>
  </div>
</template>

<script>
import NewDialog from "./dialogs/NewDialog";
import EditDialog from "./dialogs/EditDialog";
import {categories, loadConfig, loadServices, saveServices, truncateStr, addDownload} from "@/modules/services";
import api from "@/modules/api";
// import { filter } from "core-js/core/array";

export default {
  name: 'HomeComponent',
  components: {
    NewDialog,
    EditDialog,
  },

  data: () => ({
    id: null,
    dialogKey: 0,
    dialogNew: false,
    dialogEdit: false,
    values: {},
    serviceIndex: 0,
    services: [],
    config: {},
    categories: categories,
    categoryFilter: 'ACTIVE',
    searchFilter: '',
    categoryFilterApplied: 'ACTIVE',
    searchFilterApplied: '',
    parametersTextPartMap: new Map(),
    parametersFilePartMap: new Map(),
    modifiedDate: new Map(),
    apiLoaded: false,
    errorText: null,
    editable: false,
    reportStatuses: {
      DRAFT: "Черновик",
      SENT: "Отправлено"
    },
  }),

  computed: {
    filteredServices() {
      const filtered = this.services.filter((service) => this.checkFilter(service))
      return filtered
    }
  },

  methods: {
    truncateStr: truncateStr,
    applyFilters() {
      this.categoryFilterApplied = this.categoryFilter
      this.searchFilterApplied = this.searchFilter
    },

    clearFilters() {
      this.categoryFilter = 'ACTIVE'
      this.searchFilter = ''

      this.applyFilters()
    },

    search(text) {
      this.searchFilter = text
      this.applyFilters()
    },

    checkFilter(service) {
      // Проверка по категорииА
      if (this.categoryFilterApplied && service['category'] !== this.categoryFilterApplied) {
        return false;
      }
      
      // Проверка по поисковому запросу
      if (this.searchFilterApplied && this.searchFilterApplied.trim() !== '') {
        const searchLower = this.searchFilterApplied.toLowerCase();
        const fullNameMatch = service['full_name']?.toLowerCase()?.includes(searchLower) || false;
        const shortNameMatch = service['short_name']?.toLowerCase()?.includes(searchLower) || false;
        let tags = service['tags']
        if(typeof tags === 'string') {
          tags = [tags]
        }
        const tagsMatch = tags ? ("#" + tags.join("#")).toLowerCase().includes(searchLower) : false;
        
        if (!fullNameMatch && !shortNameMatch && !tagsMatch) {
          return false;
        }
      }
      
      return true;
    },

    topPopularTags() {
      let res = []
      let services = [];
      if (this.categoryFilterApplied) {
        services = this.services.filter(e => e.category === this.categoryFilterApplied)
      }
      for (let service of services) {
        if(service) {
          let tags = service['tags']
          if(!tags) {
            continue
          }
          if(typeof tags === 'string') {
            tags = [tags]
          }
          for (let tag of tags) {
            let stag = tag.replace('#', '')
            if (stag.length > 0 && !res.includes('#' + stag)) {
              res.push('#' + stag)
            }
          }
        }
      }
      return res
    },

/*
    increaseServiceDownloads(serviceIndex){
      if(this.downloadsCount[serviceIndex] === undefined){
        this.downloadsCount[serviceIndex] = 0
      } else {
        this.downloadsCount[serviceIndex]++
      }
    },
*/

    async serviceDialog(service, serviceIndex) {
      // this.increaseServiceDownloads(serviceIndex)
      this.serviceIndex = serviceIndex
      this.dialogEdit = true
      if(api.token != null) {
         service.viewsCount = Number(service.viewsCount || 0) + 1
         await saveServices(this.services)
      }
      //await addView({serviceIndex})
    },

    async onNewDialogClosed() {
      this.services = await loadServices()
      this.dialogNew = false;
      this.dialogKey++;
    },

    async deleteService(id) {
      if (confirm('Вы действительно хотите удалить сервис?')) {
        this.services = this.services.filter(e => e.id !== id)
        await saveServices(this.services)
      }
    },

    async downloadFile(fileId, fileName) {
      let req = await api.download("/uuidfs/" + fileId, {});
      if (req.ok) {
        await addDownload({fileId})
        let link = document.createElement('a');
        link.href = URL.createObjectURL(req.payload);
        link.download = fileName;
        link.click();
        URL.revokeObjectURL(link.href);
      } else {
        console.log('download error');
      }
    },

    hasDocuments(service) {

      if (service?.downloadAvailable) {
        return true;
      }
      
      // Проверяем наличие файлов в полях типа FILES
      if (this.config && this.config.fields) {
        for (const field of this.config.fields) {
          if (field.type === 'FILES' && service[field.id] && service[field.id].length > 0) {
            return true;
          }
        }
      }
      
      return false;
    },

    async exportStats() {
      const rows = []
      for(let i = 0; i < this.services.length; i++){
        rows.push([
          {cellDataType: "STRING", value: this.services[i].full_name},
          {cellDataType: "INTEGER", value: (this.services[i]?.viewsCount || 0)},
          {cellDataType: "INTEGER", value: (this.services[i]?.downloadsCount || 0)}
        ])
      }

      let query = {
        headerCells: [
          {
            caption: "Название сервиса",
            width: 5000,
          },
          {
            caption: "Количество просмотров",
            width: 5000,
          },
          {
            caption: "Количество скачиваний файлов",
            width: 5000,
          }
        ],
        rows
      }

      await this.$downloadApi("Статистика_карта_сервисов.", "/export/xlsx", query, true);
    },
    
    getVisibleFields(category) {
      let fields = this.config.fields || [];
      
      // Фильтруем поля по категории сервиса
      if (category) {
        fields = fields.filter(e => e.categories?.includes(category));
      }
      
      // Дополнительная фильтрация по флагам show и public
      if (this.$user) {
        return fields.filter(e => e.show);
      } else {
        return fields.filter(e => e.show && e.public);
      }
    }
  },

  filters: {},

  async beforeMount() {
    this.config = await loadConfig()
    this.services = await loadServices()
    
    // Инициализируем значения фильтров
    this.categoryFilterApplied = this.categoryFilter
    this.searchFilterApplied = this.searchFilter
    
    this.apiLoaded = true;
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";

.document-indicator {
  background-color: #e8f4fb;
  color: #1976d2;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-right: 10px;
  display: inline-block;
}
</style>
